import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=7cdd07be&"
import script from "./OrderList.ts?vue&type=script&lang=js&"
export * from "./OrderList.ts?vue&type=script&lang=js&"
import style0 from "./OrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports